import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("ux-video", () => {
    it("should render the video component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-video></ux-video>`);
        const el = await page.find("ux-video");
        expect(el).toHaveClass("hydrated");
    });

    it("should match to snapshot with button", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <ux-video>
                <video controls>
                    <source
                        src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
                        type="video/mp4"
                    />
                </video>
            </ux-video>
        `);
        await page.waitForChanges();
        const el = await page.find("ux-video");
        expect(el).toMatchSnapshot();
    });

    it("should match to snapshot no button", async () => {
        const page = await newE2EPage();
        await page.setContent(`
            <ux-video no-custom-play-button>
                <video autoplay muted>
                    <source
                        src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
                        type="video/mp4"
                    />
                </video>
            </ux-video>
        `);
        await page.waitForChanges();
        const el = await page.find("ux-video");
        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-video>
                <video controls>
                    <source
                        src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
                        type="video/mp4"
                    />
                </video>
            </ux-video>`);
    });
});
